import React, {type ReactElement} from "react";
import {useStaticQuery, graphql} from "gatsby";

import {LOCALE} from "/src/config";

import Navigation from "./Navigation";

interface NavigationWrapperProps {
  isSticky: boolean;
}

const NavigationWrapper = (
  props: NavigationWrapperProps
): ReactElement | null => {
  const {isSticky} = props;

  const data = useStaticQuery(
    graphql`
      query ContentfulNavComponentQuery {
        allContentfulSuperMainNavBars(
          filter: {
            contentful_id: {
              in: ["5nLv283PpHGptrWyX9FU5Z", "1fLo5OPXBM4tsJBipoVVOR"]
            }
            node_locale: {in: ["en-US", "zh-CN"]}
          }
        ) {
          nodes {
            contentful_id
            node_locale
            alertText
            promotionalText {
              promotionalText
            }
            superNavPromotionalCtaLink
            superNavPromotionalCtaText
            superNavPromotionalCtaButton {
              ...CtaButtonFragment
            }
            euPromotionalText {
              euPromotionalText
            }
            euSuperNavPromotionalCtaText
            euSuperNavPromotionalCtaLink
            euSuperNavPromotionalCtaButton {
              ...CtaButtonFragment
            }
            leavePromotionalTextBlankForEu
            mainNavPrimaryCta {
              ...CtaButtonFragment
            }
            euMainNavPrimaryCta {
              ...CtaButtonFragment
            }
            mainNavSecondaryCTA {
              ...CtaButtonFragment
            }
            euMainNavSecondaryCta {
              ...CtaButtonFragment
            }
            navTabs {
              ...NavTabLevelFragment
            }
            primaryCtaTest {
              ...TestFragment
            }
            secondaryCtaTest {
              ...TestFragment
            }
          }
        }
      }
    `
  );

  const localizedNavBar = data.allContentfulSuperMainNavBars.nodes.find(
    (el: Record<string, string>) => {
      if (LOCALE === "en-US") {
        return (
          el.contentful_id === "5nLv283PpHGptrWyX9FU5Z" &&
          el.node_locale === "en-US"
        );
      } else if (LOCALE === "zh-CN") {
        return (
          el.contentful_id === "1fLo5OPXBM4tsJBipoVVOR" &&
          el.node_locale === LOCALE
        );
      }
      return false;
    }
  );

  if (!localizedNavBar) {
    return null;
  }

  return <Navigation {...localizedNavBar} isSticky={isSticky} />;
};

export default NavigationWrapper;
